import { useCallContext } from 'helpers/hooks/use-context';

export const useUserState = () => {
  const context = useCallContext();
  const isAdvisorVolmacht = !context?.data?.gebruikerIsDeelnemer && context?.data?.volmacht && localStorage.getItem('ProxyKvk');
  return {
    isLoading: context.status === 'pending',
    userState: {
      gebruikerIsDeelnemer: context?.data?.gebruikerIsDeelnemer,
      volmacht: context?.data?.volmacht,
      proxyKvk: localStorage.getItem('ProxyKvk'),
      kringloopwijzerJaar: context?.data?.kringloopwijzerJaar,
    },
    isAdvisorVolmacht,
    proxyKvk: localStorage.getItem('ProxyKvk'),
  };
};
